import React from 'react';

import { PrimaryBanner } from './PrimaryBanner';
import type { PrimaryBannerPanelProps } from '../types';

export const PrimaryBannerPanel = ({
  bannerData,
  audiencesDataFromSegment,
  audienceOverRideForPlayground,
}: PrimaryBannerPanelProps) => {
  if (!bannerData) return null;

  return (
    <PrimaryBanner
      bannerData={bannerData}
      orientation="vertical"
      className="lg:pd-col-span-1"
      audiencesDataFromSegment={audiencesDataFromSegment}
      audienceOverRideForPlayground={audienceOverRideForPlayground}
    />
  );
};
